@import "../config/_helpers";
.breadcrumbs {
	border-radius: 10px;
	padding: 5px;
	display: flex;
	width: fit-content;
	gap: 10px;
	align-items: center;
	font-size: smaller;
	background: rgba(0, 0, 0, 0.1);
	color: black;
	margin-bottom: 20px;
	margin-top: 20px;
	> * {
		padding: 5px 10px;
		text-align: center;
		position: relative;
	}
	a {
		opacity: 0.3;
		transition: 0.4s opacity ease-in-out;
		svg {
			position: absolute;
			left: 100%;
			top: 25%;
		}

		&:hover {
			opacity: 1;
		}
	}
	span {
		font-weight: bold;
	}

	@include at-breakpoint(0, $m) {
		display: none;
	}
}
